/***
**Module Name: not found
 **File Name :  notfound.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains page not found details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router";
import * as Config from "./../constants/Config";
import Footer from "../components/footer/Footer";
import { useParams } from 'react-router-dom';
import $ from "jquery";
import Modal from 'react-bootstrap/Modal';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { contentContext } from "../context/contentContext";
import moment from "moment";
import SessionPopup from "./SessionPopup"
import FileViewer from "./docViewer";
import Loader from "../components/loader";
import InactivePopup from "./inactivePopup";

import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
} from 'react-share';
import PlayerInfo from "./player";
import { InputGroup } from "react-bootstrap";
let { lambda, appname } = window.app;


const MoreInfo = () => {
  let { id } = useParams();
  const [config, setConfig] = useState({});
  const [info, setInfo] = useState({});
  const [trailersData, setTrailersData] = useState([]);
  const [BTSData, setBTSData] = useState([]);
  const [clipsData, setClipsData] = useState([]);
  // const [contentImageData, setContentImageData] = useState([]);
  //const [menus, setMenus] = useState([]);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [playerSubTitles, setPlayerSubTitles] = useState('');

  const [toggle, setToggle] = useState(false);
  const [wishLoad, setWishLoad] = useState(false);
  const [ShowErrMsg, setShowErrMsg] = useState(false);
  const [showRequestPopup, setShowRequestPopup] = useState(false);
  const [isMailSentTwice, setIsMailSentTwice] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showDoc, setshowDoc] = useState(false);
  const location = useLocation();
  const [type, setType] = useState(false);


  const [wish, setWish] = useState(false);


  const [showSessionPopupup, setShowSessionPopupup] = useState(false);


  const [play, setPlay] = useState(false);
  const [showDescription, setShowDescription] = useState(false);

  const [activeCheckId, setActiveCheckId] = useState("");

  const [playContent, setPlayContent] = useState({});
  const [configFlag, setConfigFlag] = useState(true);
  const [fileDocName, setFileDocName] = useState("");

  const [load, setLoad] = useState("");
  const [blockedmsg, setBlockedMsg] = useState(false);


  const { isShowMyContent, inactiveFlag, userAgent, setInactiveFlag, clientData, GetClientDataFunction, wishListData, setWishListData, menus, route, setRoute, usePrevious, setContentSearchFlag, contentSearchFlag, multiSessionLoad, SetMultiSessionLoad } = useContext(contentContext);

  const prevRoute = usePrevious(route)

  useEffect(() => {
    if (prevRoute != undefined && prevRoute != route) {
      // setCurrentPage(1)
      // setRowsPerPage(15)
    }
  }, [prevRoute]);

  useEffect(() => {
    SetMultiSessionLoad(false)
    let loadurl = id.split("&");
    setContentSearchFlag(false)
    setRoute("notcontent")
    console.log("loadurl", loadurl);
    if (loadurl && loadurl[1]) {
      localStorage.setItem("url", loadurl[1])
    }
    // if (loadurl[1]) {
    //   loadMainUrl(loadurl[0]);
    // }
    if (localStorage.getItem("loc") === null) {
      userAgent();
    }
  }, []);



  useEffect(() => {
    localStorage.removeItem("check");

    getWishlistFun();
    let flag = 1;

    getContent(flag);
    if (localStorage.getItem("clientid") != null) {
      GetClientDataFunction();
      // clientActivity();
    }

  }, []);
  useEffect(() => {
    if (window.site) {
      setConfigFlag(false)
      setConfig(window.site);
    }

  }, [window.site]);
  // console.log('window.site',window.site)
  const succesNotify = () => toast.success('Your request has been sent successfully', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  },)
  const errorNotify = () => toast.error('Failed to send the request, Please Try again after some time', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  },)


  if (config.common && config.common.imagesCDN) {
    var img = config.common.imagesCDN;
  }

  if (config.common && config.common.proxiesCloudFront) {
    var proxyUrl = config.common.proxiesCloudFront
  }

  const toggleClass = () => {
    setToggle(!toggle);
  };

  // console.log('localStorage.getItem("isAddOrDelete")',localStorage.getItem("isAddOrDelete"))
  const loadMainUrl = (uri) => {
    window.location.replace("/moreinfo/" + uri);
  };

  // console.log('id',id)

  // const getContent = async (flag) => {
  //   const token = localStorage.getItem("token")
  //   const clientId = localStorage.getItem("clientid")

  //   let url = ""
  //   const showOfflineParam = id.includes('showoffline=true');
  //   const contentId = id.split("&")
  //   if (clientId != null && token != null) {
  //     url = `${lambda}/content?appname=${appname}&contentid=${contentId[0]}&clientid=${clientId}&token=${token}${showOfflineParam ? '&showoffline=true' : ''}`;
  //   }
  //   else {
  //     url = `${lambda}/content?appname=${appname}&contentid=${contentId[0]}${showOfflineParam ? '&showoffline=true' : ''}`;

  //   }


  //   // const token = localStorage.getItem("token");
  //   // const clientId = localStorage.getItem("clientid");
  //   // const contentId = id.split("&")[0];
  //   // const showOfflineParam = id.includes('showoffline=true');

  //   // const clientTokenParam = clientId && token ? `&clientid=${clientId}&token=${token}` : '';
  //   // const showOfflineSuffix = showOfflineParam && (clientId && token) ? '&showoffline=true' : '';

  //   // const url = `${lambda}/content?appname=${appname}&contentid=${contentId}${clientTokenParam}${showOfflineSuffix}`;

  //   await axios({
  //     method: 'GET',
  //     url: url
  //   })
  //     .then(function (response) {
  //       if (response?.data?.result === "content blocked to this client") {
  //         setBlockedMsg(true);
  //         localStorage.setItem("blocked", response.data.result);
  //         setLoad(response.data.result)
  //         localStorage.removeItem("info")
  //         localStorage.removeItem("item")
  //         localStorage.removeItem("isAddOrDelete")
  //       }

  //       else if (response?.data?.result != "No Content Data") {
  //         setInfo(response?.data?.result[0]);
  //         if (flag == 1) {
  //           // console.log('response?.data?.result[0]?.title',response?.data?.result[0]?.title)
  //           clientActivity(response?.data?.result[0]?.title);
  //         }
  //         let clipsData1 = response.data && response.data.result[0] && response.data.result[0].clips && response.data.result[0].clips ? response.data.result[0].clips : []
  //         setClipsData(clipsData1)

  //         if (localStorage.getItem("isAddOrDelete")) {
  //           onClickAddToWishList("", JSON.parse(localStorage.getItem("item")), localStorage.getItem("isAddOrDelete"))
  //           localStorage.removeItem("item")
  //           localStorage.removeItem("isAddOrDelete")
  //         }
  //         if (localStorage.getItem("info")) {
  //           handleRequestVideo("", JSON.parse(localStorage.getItem("info")))
  //           localStorage.removeItem("info")
  //         }

  //       }
  //       else {
  //         console.log('no content data')
  //         setShowErrMsg(true)
  //       }
  //     });
  // }

  const getContent = async (flag = 0) => {
    try {
      // ----------------------------
      // 1. Guard: id must exist
      // ----------------------------
      if (!id || typeof id !== "string") {
        console.error("Invalid content id");
        setShowErrMsg(true);
        return;
      }

      const token = localStorage.getItem("token");
      const clientId = localStorage.getItem("clientid");

      const contentId = id.split("&")[0];
      const showOfflineParam = id.includes("showoffline=true");

      // ----------------------------
      // 2. Build URL safely
      // ----------------------------
      let url = `${lambda}/content?appname=${appname}&contentid=${contentId}`;

      if (clientId && token) {
        url += `&clientid=${clientId}&token=${token}`;
      }

      if (showOfflineParam) {
        url += "&showoffline=true";
      }

      // ----------------------------
      // 3. API Call
      // ----------------------------
      const response = await axios.get(url);

      const result = response?.data?.result;

      // ----------------------------
      // 4. Handle blocked content
      // ----------------------------
      if (result === "content blocked to this client") {
        setBlockedMsg(true);
        setLoad(result);
        localStorage.setItem("blocked", result);

        localStorage.removeItem("info");
        localStorage.removeItem("item");
        localStorage.removeItem("isAddOrDelete");
        return;
      }

      // ----------------------------
      // 5. Handle no content
      // ----------------------------
      if (!result || result === "No Content Data" || !Array.isArray(result)) {
        console.warn("No content data found");
        setShowErrMsg(true);
        return;
      }

      // ----------------------------
      // 6. Success path
      // ----------------------------
      const content = result[0];

      setInfo(content);

      if (flag === 1 && content?.title) {
        clientActivity(content.title);
      }

      const clips = content?.clips || {};
      setClipsData(clips);

      // ----------------------------
      // 7. Deferred actions (wishlist / request)
      // ----------------------------
      const pendingAction = localStorage.getItem("isAddOrDelete");
      const pendingItem = localStorage.getItem("item");

      if (pendingAction && pendingItem) {
        try {
          onClickAddToWishList(
            "",
            JSON.parse(pendingItem),
            pendingAction
          );
        } catch (e) {
          console.error("Wishlist parse error", e);
        } finally {
          localStorage.removeItem("item");
          localStorage.removeItem("isAddOrDelete");
        }
      }

      const pendingInfo = localStorage.getItem("info");
      if (pendingInfo) {
        try {
          handleRequestVideo("", JSON.parse(pendingInfo));
        } catch (e) {
          console.error("Request video parse error", e);
        } finally {
          localStorage.removeItem("info");
        }
      }

    } catch (error) {
      // ----------------------------
      // 8. Global catch (VERY IMPORTANT)
      // ----------------------------
      console.error("getContent API failed", error);

      // Network / 401 / 500 / CORS / timeout
      setShowErrMsg(true);
    }
  };


  // console.log('clientData', clientData)
  const clientActivity = (title, name) => {
    console.log('titletitletitletitletitle', title)
    let path = window.location.pathname.split("/");
    const token = localStorage.getItem("token")
    const clientId = localStorage.getItem("clientid")
    // const pageName = path[path.length - 2];
    var presentTime = moment();
    console.log('info.titleinfo.titleinfo.title', title)
    let payload;

    if (title === "fileviewer") {
      payload = {
        "contentid": id,
        "title": title,
        "pagename": 'CONTENT INFO',
        "pageurl": window.location.href,
        "starttime": presentTime,
        "useragent": JSON.parse(localStorage.getItem("loc")),
        "activity": {
          pageVisited: info.title,
          action: "File Viewer",
          time: moment().format("hh:mm A"),
          actionDescription: name,
          icon: "info"
        }
      }
    } else
      if (title === "play") {
        payload = {
          "contentid": id,
          "title": title,
          "pagename": 'CONTENT INFO',
          "pageurl": window.location.href,
          "starttime": presentTime,
          "useragent": JSON.parse(localStorage.getItem("loc")),
          "activity": {
            pageVisited: info.title,
            action: "Play",
            time: moment().format("hh:mm A"),
            actionDescription: name,
            icon: "info"
          }
        }
      } else
        if (clientId != null && token != null && title !== "email" && title !== "facebook" && title !== "twitter" && title !== "linkedin") {
          payload = {
            "contentid": id,
            "title": title,
            "clientid": localStorage.getItem("clientid"),
            "pagename": 'CONTENT INFO',
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

          };

        } else {
          payload = {
            "contentid": id,
            "title": title,
            "pagename": 'CONTENT INFO',
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc")),
            "activity": {
              pageVisited: info.title,
              action: "Share",
              icon: "info",
              time: moment().format("hh:mm A"),
              actionDescription: title === "email" ? 'Shared on email' : title === "facebook" ? 'Shared on facebook' : title === "twitter" ? 'Shared on twitter' : title === "linkedin" ? 'Shared on linkedin' : ''
            }

          };
        }
    // else {
    //   payload = {
    //     "contentid": id,
    //     "title": title,
    //     "pagename": 'CONTENT INFO',
    //     "pageurl": window.location.href,
    //     "starttime": presentTime,
    //     "useragent": JSON.parse(localStorage.getItem("loc"))

    //   };
    // }



    let urlLink;
    if (localStorage.getItem("previousid")) {
      urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid") + "&token=" + token
    } else {
      urlLink = lambda + '/activity?appname=' + appname + "&token=" + token
    }

    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response.data.statusCode === 200) {
          localStorage.setItem("previousid", response.data.result)
        }
      });
  }

  const handleRequestVideo = async (e, item) => {
    console.log('iteeeeeeeeeeeeeeeeeeeeeeeeeeeeem', item)
    if (localStorage.getItem("clientid") != null && load !== "content blocked to this client") {
      try {

        const companyId = localStorage.getItem("companyid")
        // console.log('handleRequestVideo---> ', item)
        // console.log('handleRequestVideo---> ', companyId)

        const payload = {
          "companyid": companyId, "title": item.title, "genre": item.genre, "category": item.category, "contentid": id, "activity": {
            pageVisited: info.title,
            action: "Request Video",
            icon: "info",
            time: moment().format("hh:mm A"),
            actionDescription: item.title

          }
        }
        const response = await tmdbApi.requestVideo(payload);
        // console.log("response.......>", response.statusCode)
        let k = response.result == "Already sent your req"
        if (response.statusCode == 200) {
          if (response.result == "Invalid token or Expired") {
            localStorage.setItem("check", id);
            localStorage.setItem("info", JSON.stringify(info));
            setShowSessionPopupup(true)
          } else if (response.result == "Client inactived") {
            setInactiveFlag(true)

          } else {
            // console.log('asdfasdfasdfasdf', response)
            if (response.result == "Already sent your req") {
              setIsMailSentTwice(true)
            }
            setShowRequestPopup(true)

            // succesNotify()
          }
        } else {
          errorNotify()

        }
      } catch {
        console.log("error");
      }
    }
    else {

      localStorage.setItem("check", id);
      localStorage.setItem("info", JSON.stringify(info));
      navigate("/login");
    }
  }
  // console.log('JSON.parse(localStorage.getItem("info")',JSON.parse(localStorage.getItem("info")));
  const handleCloseWish = () => {

    setShow(false)
  }
  // console.log('cliepss s data',clipsData)
  const handleClose1 = (e, item) => {
    // let k = item.category
    // k = k[0] || ""
    // navigate('/content/' + k);
    const token = localStorage.getItem("token")

    const clientId = localStorage.getItem("clientid")
    console.log('close')
    if (clientId != null && token != null) {
      if (localStorage.getItem("flag")) {
        navigate("/login")
        localStorage.removeItem("flag")
        localStorage.removeItem("blocked")
      } else {
        // history.go(-1)
        navigate('/content')
        localStorage.removeItem("blocked")
      }
    } else {
      navigate('/')
      localStorage.removeItem("blocked")
    }
  }
  let description = info && info.synopsis || "";
  if (description && description.length > 400) {
    description = description.substring(0, 400) + "..."
  }
  // console.log('   setShowErrMsg(true)',ShowErrMsg)
  // const handleEnquire = (e) => {
  //   setEnquire(true);
  // }


  const onClickAddToWishList = (e, item, isAddOrDelete) => {
    setActiveCheckId(item.contentid)
    console.log('item', item)
    console.log('isAddOrDelete', isAddOrDelete)
    console.log('return')
    if (localStorage.getItem("clientid") != null) {


      if (isAddOrDelete == "Add") {

        const clientid = localStorage.getItem("clientid")

        let defaultImg = `${img}orasi/common/images/img-default.jpg`;

        let imgKey = item.portraitimage != undefined && item.portraitimage != "" ? "portraitimage" :
          item.landscapeimage != undefined && item.landscapeimage != "" ? "landscapeimage"
            : "defaultImg"

        let imgValue = item.portraitimage != undefined && item.portraitimage != "" ? item.portraitimage :
          item.landscapeimage != undefined && item.landscapeimage != "" ? item.landscapeimage
            : defaultImg

        const newObj = {
          clientid: clientid,
          appname: item.appname,
          title: item.title,
          contentid: item.contentid,
          // thumbnail: item.thumbnail,
          [imgKey]: imgValue,

          category: item.category,
          companyid: item.companyid
        }

        AddToWishlistFun([newObj])

      }
      else {
        deleteWishlistFun(item.contentid)
      }
    }
    else {
      navigate("/login");
      localStorage.setItem("check", id);
      localStorage.setItem("isAddOrDelete", isAddOrDelete);
      localStorage.setItem("item", JSON.stringify(item));
    }

  }
  const deleteWishlistFun = async (contentid) => {
    var time = moment().format("hh:mm A");

    try {
      setWishLoad(true)

      const clientid = localStorage.getItem("clientid")

      axios({
        method: 'DELETE',
        url: lambda + "/wishlist?appname=" + appname + "&clientid=" + clientid + '&token=' + localStorage.getItem("token"),
        data: {
          "contentid": [contentid], "activity": {
            pageVisited: info.title,
            action: "Removed from cart",
            icon: "info",
            time: time,
            actionDescription: info.title
          }
        },
      })
        .then(function (response) {
          console.log('response', response)
          if (response?.data?.statusCode === 200) {
            if (response?.data?.result == "Client inactived") {
              setInactiveFlag(true)
              setWishLoad(false);
              setActiveCheckId("")
              handleCloseWish();
            } else {
              console.log('response result', response?.data?.result)
              getContent();
              getWishlistFun()
              setWishLoad(false);
              handleCloseWish();
            }
          }

        });



    } catch {
      setWishLoad(false);
      console.log("error");
    }


  }
  const AddToWishlistFun = async (formvaluesObj) => {

    var time = moment().format("hh:mm A");
    try {
      //setIsLoading(true)
      setWishLoad(true)
      const response = await tmdbApi.AddToWishlist({
        'cart': formvaluesObj, "activity": {
          pageVisited: info.title,
          action: "Added to cart",
          icon: "info",
          time: time,
          actionDescription: info.title
        }
      });
      if (response.statusCode === 200) {
        if (response?.result == "Client inactived") {
          setInactiveFlag(true)

        } else {


          getContent();
          console.log('response result', response.result)
          getWishlistFun()
          setWishLoad(false);

          setTimeout(function () { setWish(false) }, 1000)
        }

      }
    } catch {
      setWishLoad(false);
      console.log("error");
    }



  }
  const handleDescription = () => {

    setShowDescription(!showDescription)
  }
  const getWishlistFun = async () => {
    try {
      const token = localStorage.getItem("token")
      const clientId = localStorage.getItem("clientid")
      if (clientId != null && token != null) {
        const response = await tmdbApi.getWishlist();
        if (response.statusCode === 200) {
          //   if(response.result == "Invalid token or Expired"){
          //     setShowSessionPopupup(true)
          // }else{
          let data = response.result && response.result && response.result.result ? response.result.result : []
          setWishLoad(false);
          if (data.length > 0) {
            setWishListData(data);

          }

          else {
            setWishListData(data);

          }
          setActiveCheckId("")
          // }
          // setActiveCheckId("")
        }
      }
    } catch {
      setActiveCheckId("")
      setWishLoad(false);
      console.log("error");
    }

  }

  const clipOrder = [
    "TRAILERS",
    "SCREENER",
    "SCRIPTS",
    "BROCHURES",
    "INTERVIEWS",
    "BEHIND THE SCENES",
    "DELETED SCENES",
    "EXTRAS",
  ];

  const clipDisplayName = (key) =>
    key.toUpperCase() === "SCRIPTS" ? "BROCHURES" : key;

  // 1️⃣ Sort main clip sections
  const orderedClipKeys = Object.keys(clipsData).sort((a, b) => {
    const aIndex = clipOrder.indexOf(a.toUpperCase());
    const bIndex = clipOrder.indexOf(b.toUpperCase());

    return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
  });
  const handlePlayer = (e, type, content) => {
    if (type === "play") {
      console.log("button clicked", content);
      clientActivity("play", content?.filename);
      setPlay(true);
      let allSubTitles = content?.subtitles
      const k = allSubTitles?.map(eachItem => {
        return { ...eachItem, path: window.site.common.proxiesCloudFront + "/" + eachItem.path }
      })
      if (content?.subtitles)
        setPlayerSubTitles(k)

      setPlayContent(content)
      console.log("playercontent----->", content);
    }
  }
  const openFileViewer = (e, content) => {
    let source = window.site.common.resourcesCDN + "/" + content.sourcepath
    setPlayContent(source);
    clientActivity("fileviewer", content?.filename);
    setFileDocName(content.name != "" && content.name != undefined ? content.name : content.filename)
    setshowDoc(true);
    setType(content.mimetype);
    console.log("playercontent==========>", content);
  }


  let picName = info.mediaType === 'video' ? 'videoclip-defaulr' : info.mediaType === 'audio' ? 'musicfile-default' : info.mediaType === 'pdf' ? 'pdf-default' : info.mediaType === 'doc' ? 'doc-defaulr' : 'img-default'
  // let defaultImg = `https://d9nwtjplhevo0.cloudfront.net/orasi/common/images/${picName}.jpg`;
  let defaultImg = `${img}orasi/common/images/img-default.jpg`;
  // let defaultImg = `${img}/orasi/common/images/${picName}.jpg`;


  // let imgUrl = info.thumbnail === "" || info.thumbnail === undefined ? defaultImg : img + info.thumbnail;
  let imgUrl =
    info.portraitimage !== undefined && info.portraitimage !== ""
      ? (info.portraitimage.startsWith("http")
        ? info.portraitimage
        : img + info.portraitimage)
      : info.landscapeimage !== undefined && info.landscapeimage !== ""
        ? (info.landscapeimage.startsWith("http")
          ? info.landscapeimage
          : img + info.landscapeimage)
        : defaultImg;




  let isAddOrDelete = info.cart && info.cart === true ? 'Delete' : 'Add';



  const handleCloseErr = () => {
    const token = localStorage.getItem("token")
    const clientId = localStorage.getItem("clientid")
    console.log('close')
    if (clientId != null && token != null) {
      navigate(-1)
    } else {
      navigate('/')
    }
    setShowErrMsg(false)
  }
  const handleCloseRequest = () => {
    setShowRequestPopup(false)
  }
  function renderListItem(title, value) {
    if (Array.isArray(value) && value.length > 0) {
      return (
        <li>
          <h6>{title}</h6>
          <p>{value.join(', ')}</p>
        </li>
      );
    } else if (typeof value === 'string' && value.trim() !== '') {
      return (
        <li>
          <h6>{title}</h6>
          <p>{value}</p>
        </li>
      );
    }
    else if (typeof value === 'number') {
      return (
        <li>
          <h6>{title}</h6>
          <p>{value}</p>
        </li>
      );
    }
    return null;
  }
  const cardWidth = $(".title-thumb").width();

  return (
    <>
      <Modal
        className="access-denied content_not_found"
        show={ShowErrMsg}
        id="access-denied-modal"
      >
        <div className="modal-body enquiry-form" id="access-denied-body">
          <div className="container" id="access-denied-container">
            <button
              className="close-btn"
              id="access-denied-close-btn"
              onClick={(e) => handleCloseErr(e)}
            >
              <span className="material-icons">close</span>
            </button>

            <span
              className="material-icons-two-tone access-denied-icon"
              id="access-denied-icon"
            >
              troubleshoot
            </span>

            <h3 id="access-denied-title">Content Not Found</h3>
            <p id="access-denied-msg">
              Unable to find the content you are looking for
            </p>

            <button
              className="fill_btn yellow-gradient"
              id="access-denied-goback-btn"
              data-bs-toggle="modal"
              data-bs-target="#recommendModal"
              onClick={(e) => handleCloseErr(e)}
            >
              go back
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        className="access-denied"
        show={showRequestPopup}
        id="request-popup-modal"
      >
        <div className="modal-body enquiry-form" id="request-popup-body">
          <div className="container" id="request-popup-container">
            <button className="close-btn" id="request-popup-close-btn">
              <span
                className="material-icons"
                id="request-popup-close-icon"
                onClick={(e) => handleCloseRequest(e)}
              >
                close
              </span>
            </button>

            <span
              className="material-symbols-outlined access-denied-icon"
              id="request-popup-icon"
            >
              mark_email_read
            </span>

            <h3 id="request-popup-title">Request Raised</h3>

            <p id="request-popup-msg">
              {`${isMailSentTwice
                ? `Your request for this video has already been raised.`
                : `Your request for a Video related to title, ${info.title}, has been raised. `
                }`}{" "}
              We will load the video at the earliest possibility. <br />
              You will receive an email once it is available.
            </p>

            <button
              className="fill_btn yellow-gradient"
              id="request-popup-ok-btn"
              data-bs-toggle="modal"
              data-bs-target="#recommendModal"
              onClick={(e) => handleCloseRequest(e)}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>

      {inactiveFlag && <InactivePopup />}
      {!inactiveFlag && showSessionPopupup && <SessionPopup />}

      {/* {showSessionPopupup && <SessionPopup />} */}
      <>
        {!ShowErrMsg && (
          <>
            {configFlag ? (
              <Loader />
            ) : (
              <div className="asset-container" id="asset-container">
                <div className="asset-container-header" id="asset-header">
                  <img
                    src={img + "orasi/client/resources/orasiv1/images/logo_white.png"}
                    className="logo"
                    id="asset-logo"
                  />
                  {(localStorage.getItem("url") && info.status === "OFFLINE") ? (
                    ""
                  ) : (
                    <button
                      className="close-btn"
                      id="asset-close-btn"
                      onClick={(e) => handleClose1(e, info)}
                    >
                      <span className="material-icons">close</span>
                    </button>
                  )}
                </div>

                {blockedmsg === false ? (
                  <>
                    <div className="asset-details-wrapper" id="asset-details-wrapper">
                      <div className="row asset-data-row" id="asset-data-row">
                        <div className="col-md-9">
                          <div className="asset-metadata" id="asset-metadata">
                            <div className="title-wrapper" id="title-wrapper">
                              <h1 className="meta-title" id="meta-title">
                                {info.title}
                              </h1>

                            </div>
                            {info.foreigntitle && <h5 className="foreign-title-detail" id="foreign-title">
                              {`(${info.foreigntitle})`}
                            </h5>}

                            <ul className="meta-data-list" id="meta-data-list">
                              <li id="category-list">
                                {info?.category &&
                                  Array.isArray(info?.category) &&
                                  info?.category.length > 0
                                  ? info.category.join(", ")
                                  : ""}
                              </li>

                              {info?.duration && (
                                <li id="duration">
                                  <span className="material-symbols-outlined">
                                    timelapse
                                  </span>{" "}
                                  {info?.duration}
                                </li>
                              )}

                              {info?.certificate ? (
                                <li id="certificate">
                                  {Array.isArray(info?.certificate) &&
                                    info?.certificate.length > 0
                                    ? info?.certificate.join(", ")
                                    : info?.certificate}
                                </li>
                              ) : null}

                              {info?.releasedate ? (
                                <li id="release-date">
                                  <span className="material-symbols-outlined me-1">
                                    rocket_launch
                                  </span>
                                  {moment(info?.releasedate).format("DD-MMM-YY")}
                                </li>
                              ) : null}
                            </ul>

                            <p className="title-description" id="title-description">
                              {description && description.substring(0, 370) + " "}
                              {description && description.length > 370 ? (
                                <button
                                  className="more-popup-btn"
                                  id="more-description-btn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#descriptionPopup"
                                  onClick={handleDescription}
                                >
                                  more
                                </button>
                              ) : null}
                            </p>

                            {Object.keys(clipsData).length <= 0 &&
                              Object.keys(info).length > 0 &&
                              (localStorage.getItem("url") &&
                                info.status === "OFFLINE" ? (
                                ""
                              ) : (
                                <button
                                  type="button"
                                  id="request-video-btn"
                                  onClick={(e) => handleRequestVideo(e, info)}
                                  className="btn btn-primary morevideos-btn"
                                  data-bs-toggle="dropdown"
                                >
                                  <span className="material-symbols-outlined me-1">
                                    video_chat
                                  </span>
                                  Request Video
                                </button>
                              ))}

                            <div className="buttons-row" id="buttons-row">
                              {orderedClipKeys.map((key, id) => {
                                const clipName = key;
                                const eachClip = clipsData[key];

                                return (
                                  <div className="dropdown me-3 mb-2" key={id}>
                                    <button
                                      type="button"
                                      className="btn btn-primary dropdown-toggle morevideos-btn"
                                      data-bs-toggle="dropdown"
                                    >
                                      <span className="material-symbols-outlined me-1">
                                        play_arrow
                                      </span>
                                      {clipDisplayName(clipName)}
                                    </button>

                                    <ul className="dropdown-menu morevideos-dd">
                                      {/* 2️⃣ Sort inside dropdown alphabetically */}
                                      {Object.keys(eachClip)
                                        .sort()
                                        .map((innerKey, i) => {
                                          const clipItem = eachClip[innerKey];
                                          const file = clipItem?.filename?.split(".")?.[0];

                                          return (
                                            <li key={i}>
                                              <button
                                                className="dropdown-item"
                                                onClick={(e) =>
                                                  clipItem.filetype === "VIDEO"
                                                    ? handlePlayer(e, "play", clipItem)
                                                    : clipItem.filetype !== "AUDIO"
                                                      ? openFileViewer(e, clipItem)
                                                      : null
                                                }
                                              >
                                                {file}
                                              </button>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                );
                              })}
                            </div>

                            <div className="meta-info-outer" id="meta-info-outer">
                              <div className="meta-info" id="meta-info">
                                <ul id="meta-list">
                                  {renderListItem("Genres", info.genre)}
                                  {renderListItem("Music Genre", info.musicgenre)}
                                  {renderListItem("Director", info.director)}
                                  {renderListItem("Languages", info.languages)}
                                  {renderListItem(
                                    "Dubbing Languages",
                                    info.dubbinglanguages
                                  )}
                                  {renderListItem("Country of Origin", info.countryorigin)}
                                  {renderListItem("Release Year", info.releaseyear)}
                                  {renderListItem("Seasons", info.noofseasons)}
                                  {renderListItem("Episodes", info.noofepisodes)}
                                  {renderListItem("Video Quality", info.videoquality)}
                                  {renderListItem("Subtitles", info.subtitleslanguages)}
                                  {renderListItem("Types of Rights", info.typeofrights)}
                                  {renderListItem(
                                    "Territories Available",
                                    info.territoriesavailable
                                  )}
                                  {renderListItem("Band Name", info.bandname)}
                                  {renderListItem("Other Artists", info.otherartists)}
                                  {renderListItem("Lyricist", info.lyricist)}
                                  {renderListItem(
                                    "Performance Type",
                                    info.performancetype
                                  )}
                                  {renderListItem("Lead Artist", info.leadartist)}
                                  {renderListItem("Sport", info.sport)}
                                  {renderListItem("Sports Stars", info.sportsstars)}
                                  {renderListItem(
                                    "League/Tournament",
                                    info.league_tournament
                                  )}
                                  {renderListItem("Meal Type", info.mealtype)}
                                  {renderListItem("Anchor", info.anchor)}
                                  {renderListItem("Chef", info.chef)}
                                  {renderListItem("Cuisine", info.cuisine)}
                                  {/* {renderListItem("Foreign Title", info.foreigntitle)} */}
                                  {renderListItem("Cast", info.cast)}
                                  {renderListItem("Awards & Recognition", info.awards_recognition)}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="title-thumb-wrapper" id="title-thumb-wrapper">
                            <div className="title-thumb" id="title-thumb">
                              <img
                                src={
                                  imgUrl.toString() +
                                  "?auto=compress,format&width=" +
                                  cardWidth
                                }
                                alt="thumb"
                                id="thumb-img"
                              />
                            </div>
                            <ul className="title-thumb-buttons mt-4" id="thumb-buttons">
                              {(localStorage.getItem("url") &&
                                info.status === "OFFLINE") ? (
                                ""
                              ) : (
                                <>
                                  {!isShowMyContent && clientData.type != "SELLER" ? (
                                    <button
                                      className="fill_btn yellow-gradient me-2"
                                      id="cart-btn"
                                      onClick={(e) =>
                                        onClickAddToWishList(e, info, isAddOrDelete)
                                      }
                                    >
                                      {info.cart && info.cart === true ? (
                                        activeCheckId === info.contentid ? (
                                          <img
                                            src={
                                              img +
                                              "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"
                                            }
                                            className="loading-icon"
                                            id="cart-loading"
                                          />
                                        ) : (
                                          <span
                                            className="material-icons done"
                                            id="cart-done"
                                          >
                                            done
                                          </span>
                                        )
                                      ) : activeCheckId === info.contentid ? (
                                        <img
                                          src={
                                            img +
                                            "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"
                                          }
                                          className="loading-icon"
                                          id="cart-loading"
                                        />
                                      ) : (
                                        <span
                                          className="material-icons add"
                                          id="cart-add"
                                        >
                                          add
                                        </span>
                                      )}
                                      CART
                                    </button>
                                  ) : null}
                                  <button
                                    className="fill_btn yellow-gradient me-2"
                                    id="share-btn"
                                    onClick={handleShow}
                                  >
                                    <span className="material-icons">share</span>
                                    Share
                                  </button>
                                </>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="blur-bg" id="blur-bg">
                      <img src={imgUrl.toString()} alt="thumb" id="blur-img" />
                    </div>
                  </>
                ) : (
                  <>
                    <button
                      className="close-btn"
                      id="blocked-close-btn"
                      onClick={(e) => handleClose1(e, info)}
                    >
                      <span className="material-icons">close</span>
                    </button>
                    <div
                      className="error-wrapper title-not-available"
                      id="error-wrapper"
                    >
                      <span className="material-symbols-outlined">privacy</span>
                      <h5 id="error-title">sorry!</h5>
                      <p id="error-msg-1">
                        This title is not available for further action,
                      </p>
                      <p id="error-msg-2">
                        Please contact your account manager for more details
                      </p>
                      <button
                        className="btn"
                        id="error-goto-btn"
                        onClick={(e) => handleClose1(e, info)}
                      >
                        go to marketplace
                      </button>
                    </div>
                  </>
                )}

                <Footer menus={menus} moreInfoCls={"fixed-footer"} />
                <ToastContainer
                  id="toast-container"
                  position="bottom-center"
                  autoClose={3000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover={false}
                  theme="light"
                />
              </div>
            )}
          </>
        )}
      </>



      <Modal
        show={show}
        className="share-modal"
        onHide={handleClose}
        id="share-modal"
      >
        <Modal.Header id="wishlist-modal-header">
          <button
            type="button"
            className="close-btn"
            aria-label="Close"
            onClick={handleCloseWish}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              position: "absolute",
              right: "16px",
              top: "16px",
              zIndex: 2
            }}
          >
            <span className="material-icons">close</span>
          </button>
          <Modal.Title id="share-modal-title">Share</Modal.Title>
        </Modal.Header>

        <Modal.Body id="share-modal-body">
          <div className="share-icons" id="share-icons">
            <div className="button-wrapper" id="share-email-btn">
              <EmailShareButton
                url={String(window.location.origin + window.location.pathname)}
                subject={info.title}
              >
                <img onClick={() => { clientActivity('email') }}
                  src={img + Config.imgmiddle + "email.png?w=60"}
                  id="share-email-icon"
                />
                <p className="u-thumb-cont-p" id="share-email-label">Email</p>
              </EmailShareButton>
            </div>

            <div className="button-wrapper" id="share-facebook-btn">
              <FacebookShareButton
                url={String(window.location.origin + window.location.pathname)}
                subject={info.title}
              >
                <img onClick={() => { clientActivity('facebook') }}
                  src={img + Config.imgmiddle + "facebook.png?w=60"}
                  id="share-facebook-icon"
                />
                <p className="u-thumb-cont-p" id="share-facebook-label">Facebook</p>
              </FacebookShareButton>
            </div>

            <div className="button-wrapper" id="share-twitter-btn">
              <TwitterShareButton
                url={String(window.location.origin + window.location.pathname)}
                title={info.title}
              >
                <img onClick={() => { clientActivity('twitter') }}
                  src={img + Config.imgmiddle + "twitter.png?w=60"}
                  id="share-twitter-icon"
                />
                <p className="u-thumb-cont-p" id="share-twitter-label">Twitter</p>
              </TwitterShareButton>
            </div>

            <div className="button-wrapper" id="share-linkedin-btn">
              <LinkedinShareButton
                url={String(window.location.origin + window.location.pathname)}
                title={info.title}
              >
                <img onClick={() => { clientActivity('linkedin') }}
                  src={img + Config.imgmiddle + "linkedin.png?w=60"}
                  id="share-linkedin-icon"
                />
                <p className="u-thumb-cont-p" id="share-linkedin-label">Linked In</p>
              </LinkedinShareButton>
            </div>
          </div>
        </Modal.Body>
      </Modal>



      <Modal
        show={wish}
        onHide={handleCloseWish}
        id="wishlist-modal"
      >
        <Modal.Header closeButton id="wishlist-modal-header"></Modal.Header>

        <Modal.Body id="wishlist-modal-body">
          {wishListData.length > 0 ? (
            <span id="wishlist-added-msg">Added from wishlist</span>
          ) : (
            <span id="wishlist-removed-msg">Removed from wishlist</span>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showDescription}
        onHide={handleDescription}
        className="modal title-des-popup"
        id="description-popup"
      >
        <Modal.Header id="description-popup-header">
          <Modal.Title id="description-popup-title">Description</Modal.Title>
          <button
            type="button"
            className="close-btn"
            onClick={handleDescription}
          >
            <span className="material-icons">close</span>
          </button>
        </Modal.Header>

        <Modal.Body id="description-popup-body">
          <p
            style={{ whiteSpace: "pre-line" }}
            id="description-popup-text"
          >
            {info.synopsis}
          </p>
        </Modal.Body>
      </Modal>

      {play ? (
        <PlayerInfo
          source={playContent}
          play={play}
          setPlay={setPlay}
          proxyUrl={proxyUrl}
          subtitles={playerSubTitles}
          id="player-info"
        />
      ) : null}

      {showDoc && (
        <FileViewer
          source={playContent}
          type={type}
          close={setshowDoc}
          name={fileDocName}
          title={info.title}
          id="file-viewer"
        />
      )}


    </>
  );
};

export default MoreInfo;